var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicationsAccepted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.287,
    height: 54.5,
    viewBox: "0 0 54.287 54.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_13_",
    "data-name": "file (13)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46614",
    "data-name": "Path 46614",
    d: "M411,8.782v9.71h9.709Z",
    transform: "translate(-367.357 -7.847)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46615",
    "data-name": "Path 46615",
    d: "M150.272,13.838a1.6,1.6,0,0,1-1.6-1.6V0H125.79A4.8,4.8,0,0,0,121,4.79V22.64c.526-.048,1.058-.073,1.6-.073a17.535,17.535,0,0,1,13.538,6.387h17.331a1.6,1.6,0,1,1,0,3.193H138.239a17.43,17.43,0,0,1,1.848,6.387h13.379a1.6,1.6,0,0,1,0,3.193H140.087a17.57,17.57,0,0,1-7.4,12.773h25.04a4.8,4.8,0,0,0,4.79-4.79V13.838Zm3.193,8.729H130.048a1.6,1.6,0,0,1,0-3.193h23.418a1.6,1.6,0,0,1,0,3.193Z",
    transform: "translate(-108.227)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_1",
    transform: "translate(0 26.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46607",
    "data-name": "Path 46607",
    d: "M16.208,2A14.208,14.208,0,1,0,30.416,16.208,14.224,14.224,0,0,0,16.208,2ZM23.18,12.534,15.315,21.81a1.022,1.022,0,0,1-.69.355h-.081a.983.983,0,0,1-.66-.244L9.348,18.035a1.018,1.018,0,0,1,1.329-1.543l3.755,3.227,7.2-8.5a1.019,1.019,0,0,1,1.553,1.319Z",
    transform: "translate(-2 -2)",
    fill: "#349823"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsAccepted);
export default __webpack_public_path__ + "static/media/applications-accepted.1436e643d5e1c1f65f3ca4d5051e7c61.svg";
export { ForwardRef as ReactComponent };